module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAATlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEoqZZAAAAGnRSTlMA/ySDx9+/exgEi/v3u6OTLI/X4+dAswybMGYgojAAAACpSURBVHgB7dY1FgNBDARR9TIz3v+g5tAak8z904F6yiSfi3BidY8BBr4p4PlBiDuFUZyIW5rleEgRi0ta4mGVONQw4JihyWGgSETTwoJjhA4mItEUMBGKBkYYYIABiwADcqdfDDDAAM54XYABBhhggAEGGODawgADDDDAgIFeNANMBKKpYMIXzQgLuSeqCQZq0c0dHhal4io8PMOSittYDbhbuKxCRPSBtvHQDtSYBZuJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/calendar-icon.png
// module id = 157
// module chunks = 0